import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/34e7caea-6d64-4eee-aba4-922db42b1f78.png"
            alt="KRUTAK Logo"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-[15px] font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'text-navy-800'
                  : scrolled
                  ? 'text-gray-600 hover:text-navy-800'
                  : 'text-gray-700 hover:text-navy-800'
              }`}
            >
              {link.label}
              {location.pathname === link.path && (
                <span className="block mt-0.5 h-0.5 w-full bg-navy-800 rounded-full" />
              )}
            </Link>
          ))}
          <Link
            to="/contact"
            className="whitespace-nowrap cursor-pointer bg-navy-800 text-white text-[14px] font-medium px-5 py-2.5 rounded-lg hover:bg-navy-700 transition-colors duration-200"
          >
            Contactez-nous
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span
            className={`block h-0.5 w-6 bg-navy-800 transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}
          />
          <span
            className={`block h-0.5 w-6 bg-navy-800 transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`}
          />
          <span
            className={`block h-0.5 w-6 bg-navy-800 transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}
          />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white border-t border-gray-100 overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-[15px] font-medium py-2 cursor-pointer ${
                location.pathname === link.path ? 'text-navy-800' : 'text-gray-600'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="whitespace-nowrap cursor-pointer bg-navy-800 text-white text-[14px] font-medium px-5 py-3 rounded-lg text-center hover:bg-navy-700 transition-colors duration-200"
          >
            Contactez-nous
          </Link>
        </nav>
      </div>
    </header>
  );
}
